import 'containers/common/Detail.css';
import SaleSheetClassificationList from "containers/salesheet/SaleSheetClassificationList";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";





export default class SaleSheetClassificationModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
         
            isLoading: true
        };
    }
    

    async componentDidMount() {
        console.log("In SaleSheetClassificationModal componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (!this.props.show) {
            return null;
        }

           
    }

    componentWillUnmount() {
        this.setState({ entities: [] });
    }

    

    

    renderSaleSheetClassifications() {
        return (
            
            <Modal
                show={this.props.show}
                onHide={this.props.toggleSaleSheetClassificationModal}
                dialogClassName="modal-90w"
                >
                <Modal.Header closeButton>
                    <Modal.Title>Sale Sheet Classifications</Modal.Title>
                </Modal.Header>
                <Modal.Body>
           
               
                

              

                        <SaleSheetClassificationList
                        filter={this.props.filter}
                        isAuthenticated={this.props.isAuthenticated}
                        isLoading={this.state.isLoading}
                        controlType="table"
                        saveForm={this.props.saveForm}
                        user={this.props.user}
                        classificationOptions={this.props.classificationOptions}
                        data={this.props.data}
                        updateTableState={this.props.updateTableState}
                        saveRecord={this.props.saveRecord}
                        deleteRecord={this.props.deleteRecord}
                        validateRelatedRecord={this.props.validateRelatedRecord}
                        salesheetid={this.props.salesheetid}
                        />

                  
          
                    </Modal.Body>
            </Modal>
        );
    }
    
    


    render() {
        return (

            <div className="SaleSheetClassificationEdit">
                {this.props.isAuthenticated ? this.renderSaleSheetClassifications() : console.log("error)")}
            </div>
        );
    }
}
